import type { ExternalUrl } from '@carboncopyco/types';
import { Button, InlineLink, TooltipBubble } from '@carboncopyco/ui';
import { usePlaybookAnalytics } from '@carboncopyco/utils';
import { usePlaybookModalState } from '../PlaybookModalContext';
import { DraggableRow } from './DraggableRow';

export const ExternalUrlRow = ({ id }: { id: string }) => {
  const { setAssets, assets, playbookId } = usePlaybookModalState();
  const asset = assets.find((asset) => asset.assetId === id);
  const item = asset.entity as ExternalUrl;
  const { trackRemovePlaybookExternalUrl } =
    usePlaybookAnalytics('playbook_modal');
  const handleRemove = () => {
    trackRemovePlaybookExternalUrl({ playbookId });
    setAssets(assets.filter((asset) => asset.assetId !== String(item.id)));
  };
  return (
    <DraggableRow
      asset={asset}
      entityType="externalUrl"
    >
      <div className="flex-auto flex items-center justify-between gap-2.5 overflow-x-hidden">
        <div className="shrink overflow-x-hidden">
          <TooltipBubble
            title={item.url}
            placement="top-start"
          >
            <InlineLink
              target="_blank"
              ellipsis
              href={item.url}
              label={item.name}
              color="text-ds-natural-600"
            />
          </TooltipBubble>
        </div>
        <div className="hidden group-hover:block">
          <Button
            xSmall
            noPadding
            blue
            link
            label="Remove"
            onClick={handleRemove}
          />
        </div>
      </div>
    </DraggableRow>
  );
};
